import * as Yup from 'yup';
import { Shape } from '../yup_types';

export enum REFUND_FORM_FIELDS {
	DISPUTE_ID = 'disputeId',
	ORDER_ID = 'orderId',
	TRANSACTION_ID = 'transactionId',
	CASE_NUMBER = 'caseNumber'
}

export enum REFUND_FORM_FIELDS_NAMES {
	DISPUTE_ID = 'Dispute Id',
	ORDER_ID = 'Order Id',
	TRANSACTION_ID = 'Transaction Id',
	CASE_NUMBER = 'Case Number'
}

export type RefundFieldsTypes = {
	[REFUND_FORM_FIELDS.DISPUTE_ID]: string,
	[REFUND_FORM_FIELDS.ORDER_ID]: string,
	[REFUND_FORM_FIELDS.TRANSACTION_ID]: string,
	[REFUND_FORM_FIELDS.CASE_NUMBER]: string,
}

export type RefundFieldsReturnTypes = {
	disputeId: string,
	orderId: string,
	transactionId: string,
	caseNumber: string,
}

// @ts-ignore
export const getRefundDetailSchema = (): Yup.SchemaOf<RefundFieldsTypes> => Yup.object<Shape<RefundFieldsTypes>>().shape({
	[REFUND_FORM_FIELDS.CASE_NUMBER]: Yup.string()
		.required('Case Number is required')
});

export const convertToInitialRefundValues = (data): RefundFieldsReturnTypes => ({
	[REFUND_FORM_FIELDS.DISPUTE_ID]: data?.id,
	[REFUND_FORM_FIELDS.ORDER_ID]: data?.orderId,
	[REFUND_FORM_FIELDS.TRANSACTION_ID]: data?.transactionId,
	[REFUND_FORM_FIELDS.CASE_NUMBER]: '',
});

export const getFormattedRefundFormFields = (formikValues): RefundFieldsTypes => ({
	disputeId: formikValues?.[REFUND_FORM_FIELDS.DISPUTE_ID],
	orderId: formikValues?.[REFUND_FORM_FIELDS.ORDER_ID],
	transactionId: formikValues?.[REFUND_FORM_FIELDS.TRANSACTION_ID],
	caseNumber: formikValues?.[REFUND_FORM_FIELDS.CASE_NUMBER],
});

